export function formatWeightAsGrams(weightMg: number): string {
  const stripped = (weightMg / 1000).toFixed(3).replace(/\.?0+$/, '')
  const [intPart, decPart] = stripped.split('.')
  const intWithCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return (decPart ? `${intWithCommas}.${decPart}` : intWithCommas) + 'g'
}
